import { render, staticRenderFns } from "./TransitionFade.vue?vue&type=template&id=46fc19cd&scoped=true&lang=pug&"
import script from "./TransitionFade.vue?vue&type=script&lang=ts&"
export * from "./TransitionFade.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionFade.vue?vue&type=style&index=0&id=46fc19cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc19cd",
  null
  
)

export default component.exports